import React, { FC, useContext } from 'react';

import { Button, H3, Tooltip } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';

import { EPromoValueType } from '../../../types';
import s from './FormComponents.module.scss';
import { IFormComponentsProps } from './interfaces';

export const Positions: FC<IFormComponentsProps> = ({
  setOpenPositionModal,
  chosenPositions,
  setChosenPositions,
  rewardType,
}) => {
  const { t } = useContext(LocalizationContext);

  return (
    <div className={s.frame}>
      <div className={s.position_top}>
        <div className={s.header}>
          <div className={s.title_block}>
            <H3>{t('promo.position')}</H3>
            <Tooltip
              contentClassName={s.tooltip}
              content={t('promo.position.tooltip')}
            />
          </div>
          <span className={s.text}>{t('promo.position.description')}</span>
        </div>

        <Button
          iconName="CirclePlusIcon"
          className={s.position_add}
          onClick={() => setOpenPositionModal && setOpenPositionModal(true)}
          disabled={rewardType !== EPromoValueType.DISCOUNT}
        >
          {t('add')}
        </Button>
      </div>

      {Boolean(chosenPositions?.length) &&
        rewardType === EPromoValueType.DISCOUNT && (
          <div className={s.items}>
            {chosenPositions?.map((item) => (
              <div key={`${item.type}-${item.id}`} className={s.item}>
                <span className={s.item_text}>{item.title}</span>
                <Button
                  onClick={() =>
                    setChosenPositions &&
                    setChosenPositions((prev) =>
                      prev.filter(
                        (pos) => !(pos.id === item.id && pos.type === item.type)
                      )
                    )
                  }
                  iconName="CloseIcon"
                  onlyIcon
                  className={s.button}
                />
              </div>
            ))}
          </div>
        )}
    </div>
  );
};
